import toast from 'react-hot-toast';

/**
 * Copy text to clipboard
 */
export async function copyToClipboard(text: string, successMessage?: string): Promise<void> {
  try {
    if (navigator.clipboard && window.isSecureContext) {
      // Use modern clipboard API
      await navigator.clipboard.writeText(text);
    } else {
      // Fallback for older browsers
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      textArea.remove();
    }
    
    toast.success(successMessage || 'Copied to clipboard!');
  } catch (error) {
    console.error('Failed to copy to clipboard:', error);
    toast.error('Failed to copy to clipboard');
  }
}

/**
 * Format environment variables for display
 */
export function formatEnvVarsForDisplay(envVars: Array<{ key: string; value: string }>): string {
  return envVars
    .map(({ key, value }) => {
      // Quote values that contain spaces or special characters
      const needsQuotes = /[\s#"'\\]/.test(value);
      const formattedValue = needsQuotes ? `"${value.replace(/"/g, '\\"')}"` : value;
      return `${key}=${formattedValue}`;
    })
    .join('\n');
}